import { useEffect, useState, type ReactNode } from 'react';
import { LanguageContext } from './LanguageContext';
import { loadTranslations } from './loadTranslations';
import type { Language, Translations } from './translations';
import { parseLanguagePath } from '@/lib/languageRouting';

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>(() => parseLanguagePath(window.location.pathname).language);
  const [dictionary, setDictionary] = useState<Translations | null>(null);

  useEffect(() => {
    let isCurrentLanguage = true;
    setDictionary(null);

    void loadTranslations(language).then((translations) => {
      if (isCurrentLanguage) {
        setDictionary(translations);
      }
    });

    return () => {
      isCurrentLanguage = false;
    };
  }, [language]);

  useEffect(() => {
    if (!dictionary) {
      return;
    }

    document.documentElement.lang = language;
  }, [dictionary, language]);

  if (!dictionary) {
    return <div className="min-h-screen bg-background" aria-busy="true" />;
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: dictionary }}>
      {children}
    </LanguageContext.Provider>
  );
}
